<template>
  <div :class="'main-layout ' + routeChecker">
    <div class="main-content">
      <Child />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'StandardLayout',

  computed: {
    ...mapState('cirt', ['info']),
    ...mapGetters('cirt', ['role']),
    // You can add specific paths to this to add custom CSS for that specific route
    routeChecker() {
      switch(this.$route.path) {
        case '/cirt':
          if (!(this.info.started && this.role)) {
            return 'cirt'
          } else {
            return ''
          }
          // Add new path cases here
          // case '/pathname': {
          // return 'classname'
          // }
          case '/survey/0':
            return 'survey'
        default:
          return ''
      }
    }
  },
}
</script>

<style scoped lang="scss">
.main-layout {
  // width: 100%;
  display:flex;
  background-color: var(--background-gray);
  height: 100%;
}

.main-content {
  flex: 1;
}

// Custom route classes
.cirt {
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url("https://pcs.byu.edu/storage/media/bf_map.png");
  height: 100%;
  width: 100%;
  overflow-x: hidden !important;
}
.survey {
  max-width: 900px;
}
</style>
